module.exports = __webpack_public_path__ + "media/images/front/centres/centre_vilareal-ec09efc58ad5f9524ede1ae388cff5b0.webp";